var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3EE9E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.432 28.703h-26.2c-.658 0-1.191-.536-1.191-1.196V1.196c0-.66.533-1.196 1.19-1.196h26.2c.659 0 1.192.535 1.192 1.196v26.31c0 .661-.533 1.197-1.191 1.197zm-25.01-2.392h23.819V2.39H19.423v23.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.649 45.452C7.016 45.46.01 38.44 0 29.77c-.01-8.67 6.976-15.708 15.609-15.723 8.633-.015 15.645 6.998 15.664 15.667a15.737 15.737 0 01-4.563 11.122 15.604 15.604 0 01-11.061 4.616zm0-29.001a13.254 13.254 0 00-12.26 8.22 13.352 13.352 0 002.888 14.516 13.214 13.214 0 0014.462 2.86c4.953-2.075 8.172-6.944 8.153-12.333-.033-7.326-5.949-13.25-13.243-13.263z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFree);
export default __webpack_public_path__ + "static/media/icon-free.3062eb2c2337f201e0f2ea1fc420a9d6.svg";
export { ForwardRef as ReactComponent };